import { Flag } from "lucide-react";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { ReporterFace } from "../../features/messages/slice-extensions/reports-slice-extension";
import ReportDialog, { ReportTarget } from "./ReportDialog";

interface ReportButtonProps {
  face: ReporterFace;
  target: ReportTarget;
  /** Pushes the button to the row's end (the message row); off inside a list of actions. */
  alignEnd?: boolean;
}

/** The quiet "Report" row action (Flag): opens the report dialog for a message or a shared file. */
const ReportButton = ({ face, target, alignEnd = false }: ReportButtonProps) => {
  const { t } = useTranslation();
  const [open, setOpen] = useState(false);

  return (
    <>
      <button
        type="button"
        className={`${alignEnd ? "ml-auto " : ""}rounded p-1 text-grey-40 hover:text-grey-20 dark:text-grey-80 dark:hover:text-white`}
        onClick={() => setOpen(true)}
        aria-label={t("messages.report.action")}
        title={t("messages.report.action")}
        data-testid="report-button"
      >
        <Flag size={14} aria-hidden="true" />
      </button>
      {open && <ReportDialog face={face} target={target} onClose={() => setOpen(false)} />}
    </>
  );
};

export default ReportButton;
